<template>
  <div>
    <div class="air__utils__heading">
      <div class="row align-items-center">
        <div class="col-md-4 col-sm-6">
          <h5>Tuition Enrollments</h5>
        </div>
        <div class="col-md-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row align-items-center w-100 justify-content-end">
            <a-select
              show-search
              allowClear
              placeholder="Filter by Program"
              style="width: 200px"
              class="mr-2 text-left"
              :options="programOptions"
              v-model="filters.tuition_program_id"
              @change="onProgramChange"
              :loading="loadingPrograms"
              :filter-option="filterOption"
            />
            <a-select
              show-search
              allowClear
              placeholder="Filter by Session"
              style="width: 200px"
              class="mr-4 text-left"
              :options="sessionOptions"
              v-model="filters.tuition_session_id"
              @change="fetchEnrollments"
              :disabled="!filters.tuition_program_id"
              :loading="loadingSessions"
              :filter-option="filterOption"
            />

            <div class="mr-2">
              <add-enrollment-modal @created="fetchEnrollments" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <tuition-enrollment-table
              :data="data"
              :loading="loadingEnrollments"
              @updateTable="fetchEnrollments"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import AddEnrollmentModal from '@/components/tuition/manage/enrollment/Add'
import TuitionEnrollmentTable from '@/components/tuition/manage/enrollment/Table'

export default {
  name: 'TuitionEnrollmentView',
  components: {
    AddEnrollmentModal,
    TuitionEnrollmentTable,
  },
  beforeMount() {
    this.$roleutility.checkpermission('tuition-enrollment', 22).then(data => {
      this.pagepermission = data.pagePermission
    })
  },
  data() {
    return {
      loadingPrograms: false,
      loadingSessions: false,
      loadingEnrollments: false,
      programs: [],
      sessions: [],
      filters: {
        tuition_program_id: undefined,
        tuition_session_id: undefined,
      },
      data: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  computed: {
    programOptions() {
      return this.programs.map(p => ({ label: p.name, value: p.id }))
    },
    sessionOptions() {
      return this.sessions.map(s => ({ label: s.name, value: s.id }))
    },
  },
  mounted() {
    this.fetchPrograms()
    this.fetchEnrollments()
  },
  methods: {
    fetchPrograms() {
      this.loadingPrograms = true
      this.$http.get('/api/tuition/programs')
        .then(({ data }) => {
          this.programs = data.data || data
        })
        .finally(() => { this.loadingPrograms = false })
    },
    onProgramChange(programId) {
      this.filters.tuition_session_id = undefined
      this.sessions = []
      this.fetchEnrollments()

      if (programId) {
        this.fetchSessions(programId)
      }
    },
    fetchSessions(programId) {
      this.loadingSessions = true
      this.$http.get(`/api/tuition/programs/${programId}/sessions`)
        .then(({ data }) => {
          this.sessions = data.data || data
        })
        .finally(() => { this.loadingSessions = false })
    },
    fetchEnrollments() {
      this.loadingEnrollments = true
      // Pass filters dynamically
      const params = {}
      if (this.filters.tuition_program_id) params.tuition_program_id = this.filters.tuition_program_id
      if (this.filters.tuition_session_id) params.tuition_session_id = this.filters.tuition_session_id

      this.$http.get('/api/tuition/enrollments', { params })
        .then(({ data }) => {
          this.data = data.data || data
        })
        .finally(() => { this.loadingEnrollments = false })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
}
</script>
